import type { StreamMessage } from '../api/artifacts'

export const decodeArtifact = async (
  response: Response,
  onResponseUpdate: (message: StreamMessage) => void,
) => {
  if (!response.body) {
    console.error('Response body is null')
    return
  }
  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  while (true) {
    const { value, done } = await reader.read() // Read chunk

    if (done) break

    buffer += decoder.decode(value, { stream: true })

    const events = buffer.split('\n\n') // SSE messages are separated by double newlines

    for (const event of events.slice(0, -1)) {
      // Process full events, keep last one in buffer
      const lines = event.split('\n')
      let data = ''

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          data += line.slice(6).trim() // Remove "data: " prefix and accumulate
        }
      }

      if (data) {
        try {
          const jsonData = JSON.parse(data) as StreamMessage
          onResponseUpdate(jsonData)
        } catch (err) {
          console.error('Failed to parse JSON:', err, 'Raw data:', data)
        }
      }
    }

    buffer = events[events.length - 1] // Keep the last unfinished part in buffer
  }
}
